// Toggle - the app's standard on/off switch (the same inline-SVG control used in the
// user create/update permission tables), promoted to a shared component and token-ised.
// Contract matches the user screens: onChange() is called with no args on click; the
// parent flips the value. Use for any boolean / 0|1 field (replaces 0-1 MUI Sliders).
//
//   <Toggle checked={!!value} onChange={() => setValue(value ? 0 : 1)} />

import React from 'react';

export default function Toggle({ checked, onChange, disabled = false, ariaLabel }) {
  const on = checked === true || checked === 1 || checked === '1';
  return (
    <svg
      onClick={disabled ? undefined : onChange}
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel}
      width="44"
      height="24"
      style={{
        cursor: disabled ? 'default' : 'pointer',
        flexShrink: 0,
        display: 'block',
        overflow: 'visible',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <rect
        x="0"
        y="0"
        width="44"
        height="24"
        rx="12"
        fill={on ? 'var(--primary)' : 'var(--border-strong)'}
        style={{ transition: 'fill 150ms' }}
      />
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="#fff"
        style={{ transform: on ? 'translateX(20px)' : 'translateX(0)', transition: 'transform 150ms' }}
      />
    </svg>
  );
}
